console.log("STANDARD PRODUCT CARDS – FLOATING BUTTONS LOADED");

document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  /* =========================
     Desktop + tablette only
  ========================= */
  const mq = window.matchMedia("(min-width: 768px)");
  if (!mq.matches) return;

  const section = document.querySelector(".standard-cards");
  if (!section) return;

  const buttons = section.querySelectorAll("[data-floating-button]");
  if (!buttons.length) return;

  /* =========================
     ÉTAT INITIAL
     → boutons posés dans la card
     → invisibles
  ========================= */
  buttons.forEach((btn) => {
    btn.classList.add("is-in-card");
    btn.classList.remove("is-floating");
  });

  gsap.set(buttons, { opacity: 0 });

  /* ======================================================
     TRIGGER GLOBAL (PAGE)
     → boutons flottants + animation + texte blanc
  ====================================================== */
  ScrollTrigger.create({
    trigger: document.body,
    start: "top+=35% top",
    end: () => section.offsetTop,
    markers: false,

    onEnter: () => {
      buttons.forEach((btn) => {
        btn.classList.add("is-floating");
        btn.classList.remove("is-in-card");
      });

      gsap.to(buttons, {
        opacity: 1,
        duration: 0.4,
        ease: "power2.out",
        stagger: 0.05
      });
    },

    onLeaveBack: () => {
      gsap.to(buttons, {
        opacity: 0,
        duration: 0.3,
        ease: "power2.in",
        onComplete: () => {
          buttons.forEach((btn) => {
            btn.classList.remove("is-floating");
            btn.classList.add("is-in-card");
          });
        }
      });
    }
  });

  /* ======================================================
     TRIGGER SECTION
     → boutons posés sur les cards
     → pas d’animation, texte noir
  ====================================================== */
  // ScrollTrigger.create({
  //   trigger: section,
  //   start: "top top",
  //   end: "bottom top",
  //   markers: false,

  //   onEnter: () => {
  //     gsap.set(buttons, { opacity: 1 });

  //     buttons.forEach((btn) => {
  //       btn.classList.remove("is-floating");
  //       btn.classList.add("is-in-card");
  //     });
  //   },

  //   onLeaveBack: () => {
  //     buttons.forEach((btn) => {
  //       btn.classList.add("is-floating");
  //       btn.classList.remove("is-in-card");
  //     });
  //   }
  // });
ScrollTrigger.create({
  trigger: section,
  start: "top top",
  end: "bottom top",
  markers: false,

  onEnter: () => {
    // fade out
    gsap.to(buttons, {
      opacity: 0,
      duration: 0.2,
      ease: "power1.out",
      onComplete: () => {
        buttons.forEach((btn) => {
          btn.classList.remove("is-floating");
          btn.classList.add("is-in-card");
        });

        // fade in
        gsap.to(buttons, {
          opacity: 1,
          duration: 0.25,
          ease: "power1.out"
        });
      }
    });
  },

  onLeaveBack: () => {
    // fade out
    gsap.to(buttons, {
      opacity: 0,
      duration: 0.2,
      ease: "power1.out",
      onComplete: () => {
        buttons.forEach((btn) => {
          btn.classList.add("is-floating");
          btn.classList.remove("is-in-card");
        });

        // fade in
        gsap.to(buttons, {
          opacity: 1,
          duration: 0.25,
          ease: "power1.out"
        });
      }
    });
  }
});

});




























// console.log("STANDARD PRODUCT CARDS – FLOATING BUTTONS LOADED");

// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   /* =========================
//      Desktop + tablette only
//   ========================= */
//   const mq = window.matchMedia("(min-width: 768px)");
//   if (!mq.matches) return;

//   const section = document.querySelector(".standard-cards");
//   if (!section) return;

//   const buttons = section.querySelectorAll("[data-floating-button]");
//   if (!buttons.length) return;

//   /* =========================
//      ÉTAT INITIAL
//      → boutons normaux + invisibles
//   ========================= */
//   gsap.set(buttons, {
//     opacity: 0
//   });

//   buttons.forEach((btn) => btn.classList.remove("is-fixed"));

//   /* ======================================================
//      TRIGGER GLOBAL (PAGE)
//      → apparition à 50% du viewport + fade in
//   ====================================================== */
//   ScrollTrigger.create({
//     trigger: document.body,
//     start: "top+=35% top",
//     end: () => section.offsetTop,
//     markers: false,

//     onEnter: () => {
//       buttons.forEach((btn) => btn.classList.add("is-fixed"));

//       gsap.to(buttons, {
//         opacity: 1,
//         duration: 0.4,
//         ease: "power2.out",
//         stagger: 0.05
//       });
//     },

//     onLeaveBack: () => {
//       gsap.to(buttons, {
//         opacity: 0,
//         duration: 0.3,
//         ease: "power2.in",
//         onComplete: () => {
//           buttons.forEach((btn) => btn.classList.remove("is-fixed"));
//         }
//       });
//     }
//   });

//   /* ======================================================
//      TRIGGER SECTION
//      → dans la section → boutons normaux (sans fade)
//   ====================================================== */
//   ScrollTrigger.create({
//     trigger: section,
//     start: "top top",
//     end: "bottom top",
//     markers: false,

//     onEnter: () => {
//       gsap.set(buttons, { opacity: 1 });
//       buttons.forEach((btn) => btn.classList.remove("is-fixed"));
//     },

//     onLeaveBack: () => {
//       buttons.forEach((btn) => btn.classList.add("is-fixed"));
//     }
//   });
// });






























// console.log("STANDARD PRODUCT CARDS – FLOATING BUTTONS LOADED");


// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   /* =========================
//      Desktop + tablette only
//   ========================= */
//   const mq = window.matchMedia("(min-width: 768px)");
//   if (!mq.matches) return;

//   const section = document.querySelector(".standard-cards");
//   if (!section) return;

//   const buttons = section.querySelectorAll("[data-floating-button]");
//   if (!buttons.length) return;

//   /* =========================
//      ÉTAT INITIAL
//      → boutons NORMAUX
//   ========================= */
//   buttons.forEach((btn) => btn.classList.remove("is-fixed"));

//   /* ======================================================
//      TRIGGER GLOBAL (PAGE)
//      → apparition à 50% du viewport
//   ====================================================== */
//   ScrollTrigger.create({
//     trigger: document.body,          // 🔑 toute la page
//     start: "top+=25% -50%",               // 50% du viewport
//     end: () => section.offsetTop,    // jusqu’à la section
//     markers: false,

//     onEnter: () => {
//       buttons.forEach((btn) => btn.classList.add("is-fixed"));
//     },

//     onLeaveBack: () => {
//       buttons.forEach((btn) => btn.classList.remove("is-fixed"));
//     }
//   });

//   /* ======================================================
//      TRIGGER SECTION
//      → dans la section → boutons normaux
//   ====================================================== */
//   ScrollTrigger.create({
//     trigger: section,
//     start: "top top",
//     end: "bottom top",
//     markers: false,

//     onEnter: () => {
//       buttons.forEach((btn) => btn.classList.remove("is-fixed"));
//     },

//     onLeaveBack: () => {
//       buttons.forEach((btn) => btn.classList.add("is-fixed"));
//     }
//   });
// });










// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   const mq = window.matchMedia("(min-width: 768px)");
//   if (!mq.matches) return;

//   const section = document.querySelector(".standard-cards");
//   const buttons = section?.querySelectorAll("[data-floating-button]");
//   if (!section || !buttons.length) return;

//   // ÉTAT INITIAL : fixed
//   buttons.forEach((btn) => btn.classList.add("is-fixed"));

//   ScrollTrigger.create({
//     trigger: section,
//     start: "top top+=1",   // 🔑 clé
//     end: "bottom top",
//     markers: false,

//     onEnter: () => {
//       buttons.forEach((btn) => btn.classList.remove("is-fixed"));
//     },

//     onLeaveBack: () => {
//       buttons.forEach((btn) => btn.classList.add("is-fixed"));
//     }
//   });
// });